import * as R from 'ramda'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Helmet } from 'react-helmet'
// Best sellers temporarily replaced by the maintenance notice while the backend is down.
// import BestSellersSlider from '../components/best-sellers-slider'
import MaintenanceNotice from '../components/maintenance-notice'
import SimpleSlider from '../components/home_slider.js'
import { Page } from '../actions'
import { createMarkup, notNilOrEmpty } from '../lib/helpers'

class App extends Component {
  componentDidMount() {
    const keys = { slug: 'home-page' }
    if (R.isEmpty(this.props.home)) this.props.fetchPage({ keys }, 'home_page')
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.slug !== this.props.match.params.slug) {
      const keys = { slug: this.props.match.params.slug }
      this.props.fetchPage({ keys }, 'home_page')
    }
  }

  render() {
    const data = this.props.home
    return (
      <main className="home-page">
        {notNilOrEmpty(data) && (
          <Helmet>
            <meta charSet="utf-8" />
            <meta name="description" content={data.meta.yoast_wpseo_metadesc} />
            <meta
              property="og:description"
              content={data.meta.yoast_wpseo_metadesc}
            />
            <meta property="og:title" content={data.meta.yoast_wpseo_title} />
            <meta property="og:type" content="website" />
            <meta property="og:url" content="https://dogfood2mydoor.com/" />
            <meta
              property="og:image"
              content={data.meta.yoast_wpseo_opengraph_image}
            />
            <title>{data.meta.yoast_wpseo_title}</title>
          </Helmet>
        )}

        {data.hero_content && <SimpleSlider {...data.hero_content} />}
        <section className="row">
          <MaintenanceNotice />
        </section>
        <div className="divider" />
        <section>
          <div className="row content-container">
            <div
              className="center-block col-md-8"
              dangerouslySetInnerHTML={createMarkup(data.content)}
            />
          </div>
        </section>
        <section className="row">
          <iframe
            className="map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3227.08526055229!2d-115.05681068445038!3d36.018211319023706!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c8d19b15fb659d%3A0xd8f1ad3a9ba38e5d!2sDog+Food+2+My+Door!5e0!3m2!1sen!2sus!4v1516563493149"
            width="100%"
            height="450"
            frameBorder="0"
            style={{ border: 0 }}
            allowFullScreen
            title="Homepage Map"
          />
        </section>
        {/* Sign-up CTA temporarily replaced with store contact info while the backend is down. */}
        <section className="newsletter row align-items-center">
          <div className="col-md-6 center-block">
            <h1 className="text-center">
              Please contact the store for any orders or help.
            </h1>
            <h3 className="text-center text-white">
              Call us at{' '}
              <a href="tel:7029712484" className="text-white">
                (702) 971-2484
              </a>{' '}
            </h3>
            <h3 className="text-center text-white">
              or email{' '}
              <a href="mailto:info@dogfood2mydoor.com" className="text-white">
                info@dogfood2mydoor.com
              </a>
            </h3>
          </div>
        </section>
      </main>
    )
  }
}

const mapStateToProps = (state) => ({
  home: state.pages.home
})

const mapDispatchToProps = (dispatch) => ({
  fetchPage: ({ keys }, type) => {
    dispatch(Page.fetchPage({ keys }, type))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(App)
